<template>
  <div>
    <PageTitle pageTitle="Security" subTitle="Error" />
    <v-row class="pa-4">
      <NavButton routeName="goToAccount" icon="mdi-account" @navigate="navigateTo" :active="isActiveRoute('goToAccount')">Account</NavButton>
      <NavButton routeName="goToAccountSecurity" icon="mdi-shield-lock" @navigate="navigateTo" :active="isActiveRoute('goToAccountSecurity')">Security</NavButton>
      <NavButton routeName="goToImages" icon="mdi-image" @navigate="navigateTo" :active="isActiveRoute('goToImages')">Image</NavButton>
    </v-row>

    <router-view></router-view>

    <v-row justify="center">
      <v-container>
        <v-card class="pa-4">
          <v-card-title class="text-h5">Upload Profile Picture</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="submitImage">
              <div class="text-center">
                <v-avatar size="100">
                  <v-img :src="previewImage || profileStore.ProfileData.image || noImage" ></v-img>
                </v-avatar>
              </div>

              <v-file-input
                v-model="image"
                label="Choose an Image"
                accept="image/*"
                outlined
                dense
                required
                @change="previewSelectedImage"
              ></v-file-input>

              <v-alert type="info" class="mt-4" outlined>
                Please upload a clear profile picture. Supported formats: PNG, JPG, JPEG.
              </v-alert>

              <v-btn color="primary" class="mt-4" type="submit" block>
                Upload Image
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-container>
      <p class="text-red-500">{{ profileStore.ProfileData.image }}</p> <br>

    </v-row>
  </div>
</template>

<script setup>
import { ref } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import NavButton from "@/components/Others/MyProfile/NavButton.vue";
import banner1 from "@/assets/images/administrator.jpg";
import { useRouter, useRoute } from 'vue-router';
import axios from "axios";
import { apiConfig } from "@/config/apiConfig";
import Swal from "sweetalert2";
import { useProfileStore } from "@/Store/profileStore";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"

const profileStore = useProfileStore();
const router = useRouter();
const route = useRoute();

const image = ref(null);
const previewImage = ref(null);

const getAccessToken = () => localStorage.getItem("accessToken");
// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;


const previewSelectedImage = () => {
  if (!image.value) {
    previewImage.value = null;
    return;
  }

  const file = Array.isArray(image.value) ? image.value[0] : image.value;
  // console.log("Selected file:", file);
  // console.log("image:", image.value);
  // console.log("previewImage:", previewImage.value);

  const reader = new FileReader();
  reader.onload = (e) => {
    previewImage.value = e.target.result;
  };
  reader.readAsDataURL(file);
};

const submitImage = async () => {
  if (!image.value) {
    Swal.fire("No Image", "Please select an image to upload!", "warning");
    return;
  }

  const file = Array.isArray(image.value) ? image.value[0] : image.value;
  const formData = new FormData();
  formData.append("image", file);

  try {
    const response = await axios.patch(
      `${apiConfig.baseUrl}${apiConfig.profileUrl}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    await profileStore.fetchProfileData(); 
    previewImage.value = null;
    image.value = null;

    Swal.fire("Success", "Image uploaded successfully!", "success");
  } catch (error) {
    console.error("Upload failed:", error);
    Swal.fire("Error", "Failed to upload image.", "error");
  }
};

const navigateTo = (routeName) => {
  router.push({ name: routeName });
};

const isActiveRoute = (routeName) => {
  return route.name === routeName;
};
</script>

<style scoped>
.v-avatar {
  border: 2px solid #ccc;
  margin-bottom: 10px;
}
</style>
